import { useEffect, useState } from 'react';
import usePrevious from '../../hooks/use-previous';
import { OnSelectChange } from '../select/types';

export interface UseAutocompleteProps {
  value?: string | number | string[];
  onSearch?: (search: string) => void;
  onChange?: (e: OnSelectChange) => void;
  name?: string;
  search?: string;
}

export default function useAutocomplete({
  value = '',
  onSearch,
  onChange,
  search = '',
}: UseAutocompleteProps) {
  const [searchQuery, setSearchQuery] = useState(search);
  const [isOptionsListVisible, setOptionsListVisible] = useState(false);

  const prevValue = usePrevious(value);

  const handleSearch = (e: { target: { value: string } }) => {
    setSearchQuery(e.target.value);

    if (onSearch) {
      onSearch(e.target.value);
    }
  };

  const onSelectChange = (e: OnSelectChange) => {
    setSearchQuery('');

    if (onChange) {
      onChange(e);
    }
  };

  useEffect(() => {
    if (value && !searchQuery) {
      setSearchQuery(search);
    } else if (prevValue && !value && searchQuery) {
      setSearchQuery('');
    }
  }, [value, searchQuery, prevValue, search]);

  return {
    isOptionsListVisible,
    setOptionsListVisible,
    searchQuery,
    handleSearch,
    onSelectChange,
  };
}
